import React from 'react';
import PropTypes from 'prop-types';

// Modifiers
const blocks = {
  SideNav: 'side-nav',
  MainContainer: 'main-container',
  SecondLevel: 'second-level',
  StepTrackerContainer: 'st-container',
  LeftSection: 'left-section',
  RightSection: 'right-section',
  MapSection: 'map-section',
  FullWidth: 'full-width',
  VerticalSectionMarker: 'vsm',
  Container: 'container'
};

const GridBlock = ({ classes = '', customStyles = {}, modifier, children }) => {
  require(`./${modifier}.css`);

  return (
    <div style={customStyles} className={`${blocks[modifier]} ${classes}`}>
      {children}
    </div>
  );
};

const allowedValues = Object.keys(blocks);

GridBlock.displayName = 'GridBlock';
GridBlock.defaultProps = { classes: '' };
GridBlock.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.string,
  customStyles: PropTypes.object,
  modifier: PropTypes.oneOf(allowedValues),
};

export default GridBlock;



// WEBPACK FOOTER //
// ./src/uis/foundations/Grids/GridBlock.js